import { render, staticRenderFns } from "./MonitoringReportDoc.vue?vue&type=template&id=56741d74&scoped=true&"
import script from "./MonitoringReportDoc.vue?vue&type=script&lang=js&"
export * from "./MonitoringReportDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56741d74",
  null
  
)

export default component.exports